var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"radio-group"},_vm._l((_vm.options),function(option){return _c('div',{key:option.id,staticClass:"radio-group__inner",class:_vm.itemClass,on:{"click":function($event){return _vm.$emit('input', option.id)}}},[_c('div',{class:{
        'radio-circle': true,
        'radio-circle--selected': _vm.value === option.id
      }}),_vm._t("default",null,{"option":option})],2)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }